import * as types from './constants';
// import { LOCAL_SAVE_QUESTIONS_WORKED } from '@/modules/exercises/_store/constants';
let correctGroupChoosed = [];
let contentForTypeFillSelect = [];

export const setValueCorrectHelper = (data, valCorrect, questionGroup = false) => {
    // let dataCorrect = valCorrect;
    // console.log('helper: ', data, valCorrect);
    if (data.type === types.TYPE_CHECKBOX || data.type === types.TYPE_X_MARK || data.type === types.TYPE_CIRCLE_ANSWER) {
        let checked = data.evt.target.checked;
        if (checked) {
            valCorrect.push({ position: data.position, value: data.evt.target.value })
        } else {
            let indexAnswer = valCorrect.findIndex(ans => ans.position === data.position) || -1;
            valCorrect.splice(indexAnswer, 1)
        }
    } else if (data.type === types.TYPE_RADIO) {
        valCorrect = [{ position: data.position, value: data.evt.target.value }]
    } else if (data.type === types.TYPE_TRUE_FALSE_NO || data.type === types.TYPE_FILL_INPUT_IMG) {
        let indexAnswer = valCorrect.findIndex(ans => ans.position === data.position);
        let valueAnswer = { position: data.position, value: data.evt.target.value };

        if (indexAnswer > -1) {
            valCorrect[indexAnswer] = valueAnswer;
        } else {
            valCorrect.push(valueAnswer);
        }
    } else if (data.type === types.TYPE_SELECT || data.type === types.TYPE_FILL_BLANK) {
        // console.log('Data for fill blank: ', data)
        let valueCurr = data.evt.target.value;
        let indexCurr = data.type === types.TYPE_SELECT ? data.select_index : data.fill_index;
        let positionDisplay = data.type === types.TYPE_SELECT ? data.position_display : indexCurr;
        let indexAnswer = valCorrect.findIndex(ans => ans.parent === `${data.position}_${indexCurr}`);
        let valueAnswer = { position: data.position, value: valueCurr, select_index: indexCurr, parent: `${data.position}_${indexCurr}`, position_display: positionDisplay };

        if (indexAnswer > -1) {
            valCorrect[indexAnswer] = valueAnswer;
        } else {
            valCorrect.push(valueAnswer);
        }
    } else if (data.type === types.TYPE_DOWN_ANSWER) {
        let valueAnswer = { position: data.position, value: data.value };
        valCorrect.push(valueAnswer);
    }
    if (questionGroup) {
        // console.log('Set question greoup: ', correctGroupChoosed, data);
        if (correctGroupChoosed.length === 0) {
            // console.log('Question 0');
            correctGroupChoosed.push({ questionId: data.questionId, correct: valCorrect });
        } else {
            let indexValCorrect = correctGroupChoosed.findIndex(cor => cor.questionId === data.questionId);
            // console.log('Set question index: ', indexValCorrect);
            if (indexValCorrect > -1) {
                correctGroupChoosed[indexValCorrect].correct = valCorrect;
            } else {
                correctGroupChoosed.push({ questionId: data.questionId, correct: valCorrect });
            }
        }
    }
    // console.log('End calc: ', valCorrect);

    return valCorrect;
}


export const getCorrectGroupChoosed = () => {
    return correctGroupChoosed;
}

export const setCorrectGroupChoosed = (correct) => {
    correctGroupChoosed = correct;
}

export const setContentQuestionFillSelect = (content) => {
    contentForTypeFillSelect = [...contentForTypeFillSelect, content];
}

export const resetContentQuestionFillSelect = () => {
    contentForTypeFillSelect = [];
}

export const getContentQuestionFillSelect = (content) => {
    return contentForTypeFillSelect;
}